import React from 'react';
import DeviceList from '../../components/devices/DeviceList';
import Page from '../../components/layout/Page';
import PageHeader from '../../components/layout/PageHeader';
import { useTranslation } from '../../i18n/i18n';
import { DeviceType } from '../../models/device';
import { weatherDetailUrl } from '../../routes.constants';

const WeatherDevicesPage = () => {
  const { t } = useTranslation('devices');
  return (
    <Page variant="list">
      <PageHeader
        crumbs={[{ label: t('breadcrumb') }, { label: t('weather.title') }]}
        title={t('weather.title')}
        subtitle={t('weather.subtitle')}
      />
      <DeviceList type={DeviceType.WEATHER} kind="weather" detailUrl={weatherDetailUrl} />
    </Page>
  );
};

export default WeatherDevicesPage;
